import React, { createContext, useContext } from 'react';
import useDesignHook from '../hooks/useDesign';

export const DesignContext = createContext();

export const DesignProvider = ({ children }) => {
  const design = useDesignHook();

  return (
    <DesignContext.Provider value={design}>
      {children}
    </DesignContext.Provider>
  );
};

export const useDesign = () => useContext(DesignContext);